import { LinkAction } from '@leverege/molten/routes';
import { Config } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { Icons, Routes, Types } from "../../constants/index.js";
export default {
  ...LinkAction.create({
    id: 'leverege.fotaApi.link.firmwareApplication',
    matches: {
      use: 'navBar',
      client: 'Main'
    },
    path: Routes.rootFirmwareApplication,
    name: 'Firmware Applications',
    layout: {
      group() {
        return Config.get('LeveregeFota', 'rootLinkGroup', ['fota']);
      },
      groupNames() {
        return Config.get('LeveregeFota', 'rootLinkGroupNames', ['Hardware']);
      },
      groupIcons() {
        return Config.get('LeveregeFota', 'rootLinkGroupIcons', [Icons.groupNav]);
      },
      sort() {
        return `${Config.get('LeveregeFota', 'rootLinkGroupSort', 'zzz')}.${Config.get('LeveregeFota', 'rootFirmwareApplicationLinkSort', 'aaa')}`;
      }
    },
    icon: () => Icons.firmwareApplicationNav
  }),
  prepare: () => {
    const delegate = DataSources.getActions({
      ref: '/firmwareApplication',
      type: Types.firmwareApplication
    });
    return GlobalState.dispatch(delegate.requestCanList());
  },
  isPrepared: () => {
    const delegate = DataSources.getActions({
      ref: '/firmwareApplication',
      type: Types.firmwareApplication
    });
    const can = delegate.canList();
    return can != null;
  },
  handles: () => {
    const delegate = DataSources.getActions({
      ref: '/firmwareApplication',
      type: Types.firmwareApplication
    });
    return delegate.canList();
  }
};